import { refineProps } from '@fullcalendar/core';
var RESOURCE_SOURCE_PROPS = {
    id: String
};
var defs = [];
var uid = 0;
export function registerResourceSourceDef(def) {
    defs.push(def);
}
export function getResourceSourceDef(id) {
    return defs[id];
}
export function doesSourceIgnoreRange(source) {
    return Boolean(defs[source.sourceDefId].ignoreRange);
}
export function parseResourceSource(input) {
    for (var i = defs.length - 1; i >= 0; i--) { // later-added plugins take precedence
        var def = defs[i];
        var meta = def.parseMeta(input);
        if (meta) {
            var res = parseResourceSourceProps((typeof input === 'object' && input) ? input : {}, meta, i);
            res._raw = input;
            return res;
        }
    }
    return null;
}
function parseResourceSourceProps(input, meta, sourceDefId) {
    var props = refineProps(input, RESOURCE_SOURCE_PROPS);
    props.sourceId = String(uid++);
    props.sourceDefId = sourceDefId;
    props.meta = meta;
    props.publicId = props.id;
    props.isFetching = false;
    props.latestFetchId = '';
    props.fetchRange = null;
    delete props.id;
    return props;
}
